import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import { useOmniBaseDataServiceKind } from "../use-omni-base-data-service-kind";
import {
  ScopeOfWorkBaseDataTable,
  ScopeOfWorkBaseDataTableFilters,
  defaultOmniScopeOfWorkBaseDataListRequest,
} from "@/services/backend/omni/scope-of-work/components/scope-of-work-base-data-table";
import { CreateScopeOfWorkBaseDataDialog } from "@/services/backend/omni/scope-of-work/components/create-scope-of-work-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function OmniScopeOfWorksBaseDataRoute() {
  const serviceKind = useOmniBaseDataServiceKind();
  const [request, setRequest] = useState(
    defaultOmniScopeOfWorkBaseDataListRequest(serviceKind),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Leistungsverzeichnisse")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen ein neues Leistungsverzeichnis angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateScopeOfWorkBaseDataDialog serviceKind={serviceKind} />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <ScopeOfWorkBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <ScopeOfWorkBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
        />
      </CardContent>
    </Card>
  );
}
